import { Operator } from '@jexop/core';

export const mergeOperator: Operator<unknown> = (props: Record<string, unknown>) => {
  const objects = props.objects;
  if (!Array.isArray(objects)) return {};

  const validObjects = objects.filter((obj): obj is Record<string, unknown> => obj !== null && typeof obj === 'object' && !Array.isArray(obj));
  return Object.assign({}, ...validObjects);
};

